import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { PopupAction } from '../../../common/popup/PopupAction'
import { deleteAlert } from '../store/thunk'
import {
  changeFilter,
  changeLoading,
  selectAlertIds,
  selectFilter,
  selectTotalPages,
} from './../store/slice'

export const DeleteCell = ({ rowId }) => {
  const dispatch = useDispatch()

  const alertIds = useSelector(selectAlertIds)
  const totalPages = useSelector(selectTotalPages)
  const filter = useSelector(selectFilter())

  const [isShow, setIsShow] = useState(false)

  const handleOpen = (e) => {
    e?.stopPropagation()
    setIsShow(true)
  }

  const handleClose = (e) => {
    e?.stopPropagation()
    setIsShow(false)
  }

  const handleDelete = (e) => {
    e?.stopPropagation()
    dispatch(changeLoading({ alertList: true }))
    dispatch(deleteAlert({ alertIds: [rowId] }))
      .unwrap()
      .then(() => {
        if (
          alertIds.length === 1 &&
          filter.page > 1 &&
          filter.page === totalPages
        ) {
          dispatch(changeFilter({ page: filter.page - 1 }))
        } else {
          dispatch(changeFilter({ triggerChange: !filter.triggerChange }))
        }
        handleClose()
      })
      .catch(() => {
        dispatch(changeLoading({ alertList: false }))
      })
  }

  return (
    <>
      <Icon
        className="icon-trash-fill"
        style={{ fontSize: 15, color: '#9C9C9C' }}
        onClick={handleOpen}
      />
      <PopupAction
        isShow={isShow}
        title="alerts.DELETE_ALERT_TITLE"
        btnCancel={{
          label: 'common.CANCEL',
          isI18n: true,
          event: handleClose,
        }}
        btnSubmit={{
          label: 'common.DELETE',
          isI18n: true,
          event: handleDelete,
        }}
        handleClose={handleClose}
      >
        <Element className="pb1">
          <Element style={{ color: '#3A414B' }}>
            <Translate value="alerts.DELETE_ALERT_MESS" />
          </Element>
        </Element>
      </PopupAction>
    </>
  )
}
